import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
  IconButton,
  TextField,
  Grid
} from '@material-ui/core';
import {
  Close as CloseIcon,
  Edit as EditIcon,
  Check as CheckIcon,
  Image as ImageIcon,
  ViewModule as ModuleIcon
} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import GameTopPanel from '../../component/game/user_interface/gameTopPanel';
import FooterPanel from '../../component/game/user_interface/gameFooterPanel';

import { withApollo } from 'react-apollo';
import config from '../../config/backend';
import {CREATE_EVENT} from '../../api/graphql-mutation'
import { getUserId } from '../../utility/function';



const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    minHeight: '100vh'
  },
  topBar: {
    backgroundColor: '#a0a0a0',
    padding: '12px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  topBarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#333'
  },
  topBarTitle: {
    fontSize: '14px',
    color: '#666'
  },
  eventTitle: {
    fontSize: '16px',
    color: 'white',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  eventTitleInput: {
    '& input': {
      color: 'white',
      fontSize: '16px',
      fontWeight: 500,
      padding: '4px 8px'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white'
      },
      '&:hover fieldset': {
        borderColor: 'white'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white'
      }
    }
  },
  editIcon: {
    fontSize: '18px',
    color: 'white',
    cursor: 'pointer'
  },
  publishButton: {
    backgroundColor: '#ff8c42',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '13px',
    padding: '8px 32px',
    '&:hover': {
      backgroundColor: '#ff7a2e'
    }
  },
  contentContainer: {
    padding: '40px'
  },
  section: {
    marginBottom: '32px'
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#666',
    marginBottom: '16px'
  },
  bannerBox: {
    backgroundColor: '#d0d0d0',
    borderRadius: '8px',
    //padding: '80px 20px',
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '16px'
  },
  bannerIcon: {
    fontSize: '64px',
    color: '#999'
  },
  uploadButton: {
    backgroundColor: '#ff8c42',
    color: 'white',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    padding: '10px 32px',
    width: '200px',
    '&:hover': {
      backgroundColor: '#ff7a2e'
    }
  },
  descriptionBox: {
    backgroundColor: '#f5f5dc',
    borderRadius: '8px',
    padding: '24px',
    minHeight: '280px',
    fontSize: '13px',
    color: '#666',
    lineHeight: 1.8,
    fontFamily: 'Georgia, serif'
  },

  templatesSection: {
    maxHeight: '500px',
    overflowY: 'auto',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#c0c0c0',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#a0a0a0'
      }
    }
  },
  templateCard: {
    backgroundColor: '#d0d0d0',
    border: '2px solid #999',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    position: 'relative'
  },
  templateHeader: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '8px',
    fontWeight: 500
  },
  templateLink: {
    fontSize: '12px',
    color: '#999',
    wordBreak: 'break-all'
  },
  templateInput: {
    marginBottom: '8px',
    '& input': {
      fontSize: '12px',
      padding: '8px'
    }
  },
  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    color: '#ff6b6b',
    padding: '4px'
  },
  addButton: {
    backgroundColor: '#ff8c42',
    color: 'white',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '14px',
    padding: '12px',
    width: '100%',
    '&:hover': {
      backgroundColor: '#ff7a2e'
    }
  }
});

class EventSettingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventName: 'New Event',
      isEditingName: false,
      templates: [
          {
            id: 1,
            name: '',
            url: '',
            description: '',
            urlValid: true,
            activityType: null,
            isNew: true
          },
          {
            id: 2,
            name: '',
            url: '',
            description: '',
            urlValid: true,
            activityType: null,
            isNew: true
          },
          {
            id: 3,
            name: '',
            url: '',
            description: '',
            urlValid: true,
            activityType: null,
            isNew: true
          }
        ],

      bannerImage: null,
      uploadingImage: false,

      eventDescription: '',
    };

    this.fileInputRef = React.createRef(); // Add ref for file input
  }

  // Add handler method:
  handleDescriptionChange = (e) => {
    this.setState({ eventDescription: e.target.value });
  }

  // Handle file input click
  handleUploadClick = () => {
    this.fileInputRef.current.click();
  }

  handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    this.setState({ uploadingImage: true });

    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await fetch(`${config.backend.uri}/api/upload`, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();
      
      if (result.data && result.data.upload && result.data.upload.url) {
        // Set the banner image URL
        // console.log(result.data.upload.url)
        this.setState({ 
          bannerImage: result.data.upload.url,
          uploadingImage: false
        });
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Failed to upload image');
      this.setState({ uploadingImage: false });
    }

    // Reset file input
    //  e.target.value = '';

  }

  toggleEditName = () => {
    this.setState(prevState => ({
      isEditingName: !prevState.isEditingName
    }));
  }

  handleNameChange = (e) => {
    this.setState({ eventName: e.target.value });
  }

  removeTemplate = (id) => {
    this.setState(prevState => ({
      templates: prevState.templates.filter(t => t.id !== id)
    }));
  }

  addNewTemplate = () => {
    const newTemplate = {
      id: Date.now(),
      name: '',
      url: '',
      description: '',
      urlValid: true,
      activityType: null,
      isNew: true
    };
    this.setState(prevState => ({
      templates: [...prevState.templates, newTemplate]
    }));
  }

  // handleTemplateChange = (id, field, value) => {
  //   this.setState(prevState => ({
  //     templates: prevState.templates.map(t =>
  //       t.id === id ? { ...t, [field]: value } : t
  //     )
  //   }));
  // }


  handlePublishEvent = async () => {
    const { eventName, bannerImage, eventDescription, templates } = this.state;

    // Validate all URLs before publishing
    const hasInvalidUrl = templates.some(t => t.url && !t.urlValid);
    
    if (hasInvalidUrl) {
      alert('Please fix invalid activity URLs before publishing. Each URL must point to a Jam Builder, Game, or Event — e.g. /jambuilder/{id}, /game/{id}, or /event/page/{id} (a full link from any site works too).');
      return;
    }

    // Filter out empty templates and store a canonical, host-independent link
    // (/jambuilder/<id>, /game/<id>, /event/page/<id>). Users may paste a full URL from any
    // site or a bare path; normalizing here guarantees the published event page classifies
    // and opens each link correctly regardless of which deployment created it.
    const activities = templates
      .filter(t => t.name && t.url)
      .map(t => {
        const { type } = this.validateActivityUrl(t.url);
        const idMatch = t.url.match(/([a-f0-9]{24})/i);
        const id = idMatch ? idMatch[1] : t.url;

        let link = t.url;
        if (type === 'jambuilder') link = `/jambuilder/${id}`;
        else if (type === 'game') link = `/game/${id}`;
        else if (type === 'event') link = `/event/page/${id}`;

        return {
          name: t.name,
          link,
          description: t.description || '',
        };
      });

    try {
      const { data } = await this.props.client.mutate({
        mutation: CREATE_EVENT,
        variables: {
            name: eventName,
            createdBy: getUserId(),
            bannerImage: bannerImage,
            description: eventDescription,
            activity: activities,
        },
      });

      // console.log('Event created:', data.eventCreateOne);
      
      const eventId = data.eventCreateOne._id;
      window.location.href = `/event/page/${eventId}`;
      
    } catch (error) {
      console.error('Error publishing event:', error);
      alert('Failed to publish event');
    }
  };

    // Add to component
  validateActivityUrl = (url) => {
    if (!url) return { isValid: true, type: null }; // Empty is okay

    // Domain-agnostic: accept a full link from ANY deployment (prod domain, temp IP-based
    // site, or localhost) OR a bare path — we only require the /<type>/<24-hex-id> segment.
    // The published event page rebuilds navigation from the extracted id (relative path),
    // so the host in the pasted link doesn't matter. This avoids rejecting a link that was
    // generated on a different site than the one currently being used.
    let cleanUrl = url.trim()
      .replace(/^https?:\/\//, '') // Remove http:// or https://
      .replace(/^www\./, '');       // Remove www.
    // console.log(cleanUrl)
    const patterns = [
      { regex: /(?:^|\/)jambuilder\/[a-f0-9]{24}$/i, type: 'jambuilder' },
      { regex: /(?:^|\/)game\/[a-f0-9]{24}$/i, type: 'game' },
      { regex: /(?:^|\/)event\/page\/[a-f0-9]{24}$/i, type: 'event' },
    ];

    for (let pattern of patterns) {
      if (pattern.regex.test(cleanUrl)) {
        return { isValid: true, type: pattern.type };
      }
    }

    return { isValid: false, type: null };
  }

  getActivityTypeLabel = (type) => {
    switch(type) {
      case 'jambuilder':
        return { text: 'Jam Builder', color: '#5a8a90' };
      case 'game':
        return { text: 'Game', color: '#ff8c42' };
      case 'event':
        return { text: 'Event', color: '#9b59b6' };
      default:
        return null;
    }
  }

  handleTemplateChange = (id, field, value) => {
    this.setState(prevState => {
      const updatedTemplates = prevState.templates.map(t => {
        if (t.id === id) {
          const updated = { ...t, [field]: value };
          
          // If changing URL, validate it
          if (field === 'url') {
            const validation = this.validateActivityUrl(value);
            updated.urlValid = validation.isValid;
            updated.activityType = validation.type;
          }
          
          return updated;
        }
        return t;
      });
      
      return { templates: updatedTemplates };
    });
  }

  render() {
    const { classes } = this.props;
    const { eventName, isEditingName, templates, bannerImage, uploadingImage } = this.state;
    // console.log(this.state.templates)

    return (
        <>
            <GameTopPanel/>
            <Box className={classes.root}>
                {/* Top Bar */}
                <Box className={classes.topBar}>
                    <Box className={classes.topBarLeft}>
                        <ModuleIcon />
                        <Typography className={classes.topBarTitle}>
                            Event Setting
                        </Typography>
                    </Box>
                    <Box className={classes.eventTitle}>
                        {isEditingName ? (
                            <TextField
                                variant="outlined"
                                size="small"
                                value={eventName}
                                onChange={this.handleNameChange}
                                className={classes.eventTitleInput}
                                autoFocus
                            />
                        ) : (
                            <span>{eventName}</span>
                        )}
                        <IconButton size="small" onClick={this.toggleEditName} style={{ color: 'white' }}>
                            {isEditingName ? <CheckIcon className={classes.editIcon} /> : <EditIcon className={classes.editIcon} />}
                        </IconButton>
                    </Box>
                    <Button onClick={this.handlePublishEvent} variant="contained" className={classes.publishButton}>
                        Publish Event
                    </Button>
                </Box>

                {/* Main Content */}
                <Container maxWidth="lg" className={classes.contentContainer}>
                    <Grid container spacing={4}>
                        {/* Left Column */}
                        <Grid item xs={12} md={7}>
                            {/* Banner Image Section */}
                            <Box className={classes.section}>
                                <Typography className={classes.sectionTitle}>
                                    Banner Image
                                </Typography>
                                <Box className={classes.bannerBox}>
                                    {bannerImage ? (
                                        <img 
                                            src={`${config.backend.uri}/static/uploads/${bannerImage}`} 
                                            alt="Banner" 
                                            style={{ 
                                                width: '100%', 
                                                height: '100%', 
                                                objectFit: 'cover',
                                                borderRadius: '8px'
                                            }}
                                        />
                                    ) : (
                                        <ImageIcon className={classes.bannerIcon} />
                                    )}
                                </Box>
                                 <input
                                    ref={this.fileInputRef}
                                    type="file"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={this.handleFileChange}
                                />
                                <Button 
                                    variant="contained" 
                                    className={classes.uploadButton}
                                    onClick={this.handleUploadClick}
                                    disabled={uploadingImage}
                                >
                                    {uploadingImage ? 'Uploading...' : 'Upload Image'}
                                </Button>
                            </Box>

                            {/* Event Descriptions Section */}
                            <Box className={classes.section}>
                                <Typography className={classes.sectionTitle}>
                                  Event Descriptions
                                </Typography>
                                <TextField
                                  fullWidth
                                  multiline
                                  rows={10}
                                  variant="outlined"
                                  value={this.state.eventDescription}
                                  onChange={this.handleDescriptionChange}
                                  className={classes.descriptionBox}
                                  placeholder="Enter event description here..."
                                  InputProps={{
                                    style: {
                                      fontSize: '13px',
                                      color: '#666',
                                      lineHeight: 1.8,
                                      fontFamily: 'Georgia, serif',
                                      padding: '24px'
                                    }
                                  }}
                                />
                              </Box>

                        </Grid>

                        {/* Right Column */}
                        <Grid item xs={12} md={5}>
                          <Box className={classes.section}>
                            <Typography className={classes.sectionTitle}>
                              Event Templates
                            </Typography>

                            <Box className={classes.templatesSection}>
                              {templates.map(template => (
                                <Box key={template.id} className={classes.templateCard}>
                                  <IconButton 
                                    className={classes.closeButton}
                                    size="small"
                                    onClick={() => this.removeTemplate(template.id)}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Typography className={classes.templateHeader} style={{ marginBottom: 0 }}>
                                      Activity URL
                                    </Typography>
                                    {template.activityType && template.urlValid && (
                                      <span 
                                        style={{ 
                                          fontSize: '11px', 
                                          fontWeight: 600, 
                                          color: this.getActivityTypeLabel(template.activityType).color,
                                          padding: '3px 10px',
                                          backgroundColor: `${this.getActivityTypeLabel(template.activityType).color}20`,
                                          borderRadius: '12px',
                                          whiteSpace: 'nowrap'
                                        }}
                                      >
                                        {this.getActivityTypeLabel(template.activityType).text}
                                      </span>
                                    )}
                                  </div>
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={template.url}
                                    onChange={(e) => this.handleTemplateChange(template.id, 'url', e.target.value)}
                                    className={classes.templateInput}
                                    error={template.url && !template.urlValid}
                                    helperText={template.url && !template.urlValid ? 'Invalid URL format' : ''}
                                    style={{ paddingRight: '24px' }}
                                  />
                                  <Typography className={classes.templateHeader}>
                                    Activity Name
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={template.name}
                                    onChange={(e) => this.handleTemplateChange(template.id, 'name', e.target.value)}
                                    className={classes.templateInput}
                                    style={{ paddingRight: '24px' }}
                                  />
                                  
                                  <Typography className={classes.templateHeader}>
                                    Activity Description
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={template.description}
                                    onChange={(e) => this.handleTemplateChange(template.id, 'description', e.target.value)}
                                    multiline
                                    rows={2}
                                    className={classes.templateInput}
                                    style={{ paddingRight: '24px' }}
                                  />
                                </Box>
                              ))}
                            </Box>

                            <Button 
                              variant="contained" 
                              className={classes.addButton}
                              onClick={this.addNewTemplate}
                            >
                              Add Activity URL
                            </Button>
                          </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <FooterPanel/>
        </>
    );
  }
}

export default withApollo(withStyles(styles)(EventSettingPage));